export enum MedicinesEnum {
  MENU = 'menu',
  DESCRIPTION = 'description',
  PRECAUTIONS = 'precautions',
  EFFECTS = 'effects',
  DOSIS = 'dosis',
  PRESENTATION = 'presentation'
}